import {MouseEvent} from 'react';

import {suffixTestId, TestIdProps} from 'shared/web';

import {StyledMenuItem} from '../../Dropdown/components/CustomMenuItem';
import {Dropdown} from '../../Dropdown/Dropdown';
import {TemplateTokenSuggestionMenuState} from './createTemplateTokenSuggestionMenu';

interface TemplateTokenSuggestionMenuProps extends TestIdProps {
  state: TemplateTokenSuggestionMenuState;
  onSelect: (index: number) => void;
  onHighlight: (index: number) => void;
  onDismiss: () => void;
}

// The editor keeps the focus and the caret while an item is clicked.
const keepEditorFocus = (event: MouseEvent) => event.preventDefault();

/** The `/` menu at the caret, styled as the menu of the template editor (`SuggestionInput`). */
export function TemplateTokenSuggestionMenu(props: TemplateTokenSuggestionMenuProps) {
  return (
    <div
      style={{position: 'absolute', top: props.state.anchor.top, left: props.state.anchor.left}}
      data-testid={suffixTestId('templateTokenMenuAnchor', props)}
    >
      <Dropdown
        isOpen
        dropdownControl={<div />}
        onClose={props.onDismiss}
        isFocusManagementDisabled
        isKeyboardNavigationDisabled
        isHeightLimited
        data-testid={suffixTestId('templateTokenMenu', props)}
      >
        <ul role="listbox">
          {props.state.items.map((item, index) => (
            <StyledMenuItem
              key={item.code}
              role="option"
              aria-selected={index === props.state.activeIndex}
              $isSelected={index === props.state.activeIndex}
              onMouseDown={keepEditorFocus}
              onMouseEnter={() => props.onHighlight(index)}
              onClick={() => props.onSelect(index)}
            >
              {item.label}
            </StyledMenuItem>
          ))}
        </ul>
      </Dropdown>
    </div>
  );
}
